import React from "react";
import classnames from "classnames";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { updatearticle } from "../../actions/category";
import { withRouter } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";

import $ from "jquery";
import { Editor } from "@tinymce/tinymce-react";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import axios from "axios";
import {CKEditor}from 'ckeditor4-react'
import keys from "../../actions/config";
const url = keys.baseUrl;
const imageurl = keys.imageUrl;

class ArticleupdateModal extends React.Component {
  constructor(props) {
    super(props);
    $("#update-subcategory-modal")
      .find(".text-danger")
      .hide();
    this.state = {
      categoryName: "",
      status: "",
      curimage:null,
      errors: {},
      categoryName1: "",
      subcategoryName: "",
      maincategoryId: "",
      categoryName2: "",
      subcategoryId: "",
      subcategorydropdown: "",
      subcategoryName1: "",
      articlename: "",
      articlename_update: "",
      subcategoryoption: [],
      content: "",
      article_image:"",
      query_image: ""
    };
    this.handleEditorChange = this.handleEditorChange.bind(this);

  }

  styles = {
    option: (styles, {isFocused, isSelected}) => ({
      ...styles,
      color: "#fff",
      background: isFocused
          ? '#bdbdbd'
          : isSelected
              ? '#005eb8'
              : "#808080",
      zIndex: 1
  }),
    valueContainer: (provided, state) => ({
      ...provided,
      height: '52px',
      padding: '0 6px',
      backgroundColor: "#03081f",
      borderColor: '#81c8f6',
    borderRadius: 10,
    borderStyle: 'solid',
    borderWidth: '1px'
     
    }),
    control: (provided, state) => ({
      ...provided,
      height: '52px',
      borderRadius:10,
      backgroundColor: "#03081f",
      border:'none'
     
    }),
    indicatorsContainer: (provided, state) => ({
      ...provided,
      height: '52px',
      position: 'absolute',
      right: 0,
      top: 0,
      color:'#fff' 
    }),    
    singleValue: (provided, state) => ({
      ...provided,
      color: "#fff"
    }),
    menuList: base => ({
      ...base,
      // kill the white space on first and last option
      padding: 0
    })
  };
  componentWillReceiveProps(nextProps) {
    console.log(nextProps,"nextProps")
    if (nextProps.record) {
      console.log(nextProps.record,"nextProps.record")
      console.log("nextpropss in arti update", nextProps);
      if (nextProps.record.maincategoryId) {
        var maincategoryId = {
          value: nextProps.record.maincategoryId._id,
          label: nextProps.record.maincategoryId.categoryName
        };
        this.setState({
          id: nextProps.record._id,
          articlename_update: nextProps.record.Articlename,
          categoryName: nextProps.record.maincategoryId._id,
          subcategoryName: nextProps.record.subcategoryName,
          content:nextProps.record.content,
          maincategoryId: maincategoryId,
          subcategoryId: subcategoryId,
          hidden1: nextProps.record.categoryName,
          article_image:nextProps.record.article_image,
          errors: ""
        });
      }
      if (nextProps.record.subcategoryId) {
        var subcategoryId = {
          value: nextProps.record.subcategoryId._id,
          label: nextProps.record.subcategoryId.subcategoryName
        };
        this.setState({
          id: nextProps.record._id,
          articlename_update: nextProps.record.Articlename,
          categoryName: nextProps.record.maincategoryId._id,
          subcategoryName: nextProps.record.subcategoryName,
          content:nextProps.record.content,
          maincategoryId: maincategoryId,
          subcategoryId: subcategoryId,
          hidden1: nextProps.record.categoryName,
          errors: ""
        });
      }

      //   this.handleChange()
    }
    if (nextProps.errors) {
      $("#update-subcategory-modal")
        .find(".text-danger")
        .show();
      this.setState({
        errors: nextProps.errors
      });
    } else {
      this.setState({
        errors: ""
      });
    }
    // console.log(nextProps)
    if (
      nextProps.auth !== undefined &&
      nextProps.auth.currencyupdate !== undefined &&
      nextProps.auth.currencyupdate.data !== undefined &&
      nextProps.auth.currencyupdate.data.message !== undefined &&
      nextProps.auth.currencyupdate.data.success
    ) {
      $("#update-subcategory-modal").modal("hide");
      toast(nextProps.auth.currencyupdate.data.message, {
        position: toast.POSITION.TOP_CENTER
      });
      nextProps.auth.currencyupdate = "";
      this.setState({
        errors: ""
      });
    }
  }

  //   onChange = e => {
  //     $("#update-subcategory-modal")
  //       .find(".text-danger")
  //       .show();
  //     if (e.target.id === "currency-update-categoryName") {
  //       this.setState({ categoryName: e.target.value });
  //     }
  //   };

  onChange = e => {
    this.setState({ [e.target.id]: e.target.value });
  };
  handleEditorChange(e) {
    this.setState({"content":e.editor.getData()});
  }

  handleChangefile = event => {
    this.setState({
      curimage: URL.createObjectURL(event.target.files[0]),
      query_image: event.target.files[0]
    });
  };


  handleChange = selectedOption => {
    this.setState({ categoryName: selectedOption.value });
    console.log(`Option selected:`, selectedOption);
    var data = {
      categoryid: selectedOption.value
    };
    axios.post(url + "api/sub-category-select-find", data).then(subcategory => {
      console.log("Response dataaaaaaaaaaaaaaaa====>", subcategory);
      var subcategoryarray = [];
      subcategory.data.map((item, i) => {
        
        const name = item.subcategoryName;
        const value = item._id;
         console.log(value, "valuevalue");
        const obj = { value: value, label: name };
        subcategoryarray.push(obj);
      });
      console.log(subcategoryarray, "subcategoryarray");
      this.setState({
        subcategoryoption: subcategoryarray,
        email_assigned: true
      });
    });
  };

  handleChange1 = selectedOption => {
    this.setState({ subcategorydropdown: selectedOption });
    // console.log(`Option selected:`, selectedOption );
  };

  componentDidMount() {
    console.log("call here");
    // this.setState({ errors: "" });
    this.getData();
  }

  getData() {
    axios
      .get(url + "api/helpcentrecategory")
      .then(subcategory => {
        var categoryarray = [];
        subcategory.data.map((item, i) => {
          const name = item.categoryName;
          const value = item._id;
          const obj = { value: value, label: name };
          categoryarray.push(obj);
        });
        console.log(categoryarray, "categoryarray===");
        this.setState({ categoryName1: categoryarray, email_assigned: true });
      })
      .catch();
  }

  onArticleupdate = e => {
    e.preventDefault();
    $("#update-article-modal")
      .find(".text-danger")
      .show();
    const newcategory = {
      _id: this.state.id,
      articlenamee: this.state.articlename_update,
      subcategoryName: this.state.subcategorydropdown.value,
      categoryName: this.state.categoryName
    };

    const data = new FormData();

    data.append("_id", this.state.id);
    data.append("articledetails", this.state.articlename_update);
    data.append("maincategoryId", this.state.categoryName);
    data.append("subcategoryId",  this.state.subcategorydropdown.value);
    data.append("content", this.state.content);
    data.append("file", this.state.query_image);
    // console.log("New article to update", newcategory);

    axios
      .post(url + "api/helpcentrearticle-update", data)
      .then(res => {
        if (res.status === 200) {
          toast(res.data.message, {
            position: toast.POSITION.TOP_CENTER
          });
          this.props.onHide()
          this.setState({"content":""})
          $("#update-article-modal").modal("hide");
          this.props.getData()
        }
      })
      .catch();
    this.getData();
    this.props.getData()
    this.props.onHide()
    // this.props.updatearticle(newcategory);
  };

  render() {
    const {
      errors,
      maincategoryId,
      selectedOption,
      subcategoryId,
      subcategoryName1,
      subcategoryoption,
      subcategorydropdown
    } = this.state;
    const {onHide} = this.props

    return (
      <div>
        <div className="modal fade" id="update-article-modal">
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Update Category</h4>
                <button type="button" className="close" data-dismiss="modal" onClick={()=>{onHide();this.setState({content:""})}}>
                  &times;
                </button>
              </div>
              <div className="modal-body">
                <form
                  noValidate
                  onSubmit={this.onArticleupdate}
                  id="update-subcategory"
                >
                  <input
                    onChange={this.onChange}
                    value={this.state.id}
                    id="category-update-id"
                    type="text"
                    className="d-none"
                  />
                  <input
                    onChange={this.onChange}
                    value={this.state.hidden}
                    id="hidden"
                    type="text"
                    className="d-none"
                  />
                  <input
                    onChange={this.onChange}
                    value={this.state.hidden1}
                    id="hidden1"
                    type="text"
                    className="d-none"
                  />
                  <div className="row mt-2">
                    <div className="col-md-3">
                      <label htmlFor="currencyName">Article Name</label>
                    </div>
                    <div className="col-md-9">
                      <input
                        onChange={this.onChange}
                        value={this.state.articlename_update}
                        id="articlename_update"
                        type="text"
                        // error={errors.currencyName}
                        className={classnames(
                          "form-control"
                          // , { invalid: errors.currencyName}
                        )}
                      />
                      <span className="text-danger">{errors.currencyName}</span>
                    </div>
                  </div>


                  <div className="row mt-2">
                    <div className="col-md-3">
                      <br />
                      <label htmlFor="query_image">Image</label>
                    </div>
                    <div className="col-md-6">
                    <label class="custom-file-upload">
                      <input type="file" onChange={this.handleChangefile} />
                     Choose File
                      </label>
                      {this.state.curimage !=null ?(
                        <img
                            className="img-fluid proofThumb mb-3"
                            src={this.state.curimage}
                          />
                      )
                      :
                      (
                         <img
                          className="img-fluid proofThumb mb-3"
                          src={imageurl + "helpcentre/" + this.state.article_image}
                        />
                      )
                    }
                      {/*<img width="100px" src={this.state.query_image} />*/}
                    </div>
                  </div>


                  <div className="row mt-2">
                    <div className="col-md-3">
                      <label htmlFor="content">Content</label>
                    </div>
                    <div className="col-md-9">
                      {/* <Editor
                        apiKey="5vk89nvvi2zckrb2lp2ctyyolewhq1v3pzdiwb7at68h40a5"
                        initialValue="<p>This is the initial content of the editor</p>"
                        value={this.state.content}
                        onEditorChange={this.handleEditorChange}
                        init={{
                          height: 500,
                          menubar: false,
                          plugins: [
                            "advlist autolink lists link image charmap print preview anchor",
                            "searchreplace visualblocks code fullscreen",
                            "insertdatetime media table paste code help wordcount"
                          ],
                          toolbar:
                            "undo redo code | formatselect | bold italic backcolor | \
                                               alignleft aligncenter alignright alignjustify | \
                                               bullist numlist outdent indent | removeformat | help"
                        }}
                      /> */}
                      {console.log(this.state.content,"content")}
                      {this.state.content && 
                      <CKEditor
                      config={{
                        extraAllowedContent: 'div(*)',
                        allowedContent: true,
                        height: 500,
                      }}
                      initData={this.state.content}
                      onChange={this.handleEditorChange}
                    />
                      }
                       
                      <span className="text-danger">{errors.content}</span>
                    </div>
                  </div>





                  <div className="row mt-2">
                    <div className="col-md-3">
                      <label htmlFor="first_currency">Main Category</label>
                    </div>
                    <div className="col-md-9">
                      {console.log(this.state.maincategoryId,this.state.categoryName1)}
                      {this.state.maincategoryId ? (
                        <Select isSearchable={false}
                          value={selectedOption}
                          defaultValue={{
                            label: maincategoryId.label,
                            value: maincategoryId.value
                          }}
                          onChange={this.handleChange}
                          options={this.state.categoryName1}
                          styles={this.styles} className="border_blue_select"
                        />
                      ) : (
                        ""
                      )}
                      <span className="text-danger">
                        {errors.first_currency}
                      </span>
                    </div>
                  </div>

                  <div className="row mt-2">
                    <div className="col-md-3">
                      <label htmlFor="first_currency">Sub Category</label>
                    </div>
                    <div className="col-md-9">
                      {console.log(subcategoryoption,"subcategoryoption")}
                      {subcategoryoption.length == 0 ? (
                        <span className="text-danger">
                          Please Select the other category
                        </span>
                      ) : (
                        <Select isSearchable={false}
                          value={subcategorydropdown}
                          defaultValue={{
                            label: subcategoryId.label,
                            value: subcategoryId.value
                          }}
                          onChange={this.handleChange1}
                          options={subcategoryoption}
                          styles={this.styles} className="border_blue_select"
                        />
                      )}
                      <span className="text-danger">
                        {errors.first_currency}
                      </span>
                    </div>
                  </div>
                </form>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-outline"
                  data-dismiss="modal"
                  onClick={()=>{onHide();this.setState({content:""})}}
                >
                  Close
                </button>
                <button
                  form="update-subcategory"
                  type="submit"
                  className="btn btn-primary"
                >
                  Update Article
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ArticleupdateModal.propTypes = {
  updatearticle: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  auth: state.auth,
  errors: state.errors
});

export default connect(mapStateToProps, { updatearticle })(
  withRouter(ArticleupdateModal)
);
